import React, { useEffect, useRef, useState } from "react";

interface TagProps {
  index: number;

  text: string;
  onChange: (index: number, newText: string) => void;
  handleTagDelete: Function;
  handleTagEdit: Function;
}

const TagComponent: React.FC<TagProps> = ({
  index,
  text,
  onChange,
  handleTagDelete,
  handleTagEdit,
}) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<string>(text);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.innerText = text; // Set initial text
    }
  }, [text]);

  const handleInput = () => {
    if (divRef.current) {
      const newText = divRef.current.innerText;
      setContent(newText); // Update local state with the edited text
    }
  };

  const handleBlur = (e) => {
    e.stopPropagation();
    onChange(index, content);
    setTimeout(() => {
      setIsFocused(false);
    }, 200);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  return (
    <div className="d-flex align-items-center justify-content-between bg-dark font-weight-bold text-white py-1 px-1 rounded min-w-70px instagramUserTagBox">
      <div
        style={{ width: "100%" }}
        spellCheck={false}
        contentEditable={true}
        suppressContentEditableWarning={true}
        ref={divRef}
        onInput={handleInput}
        onBlur={handleBlur}
        onFocus={handleFocus}
      ></div>{" "}
      {isFocused ? (
        <i
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{ zIndex: 11 }}
          className="fa-sharp-duotone fa-solid fa-check icon-xs text-success float-end ms-3 pe-1 cursor-pointer"
        ></i>
      ) : (
        <i
          onClick={(e) => {
            e.stopPropagation();
            handleTagDelete(index);
          }}
          className="fa-solid fa-xmark icon-xs text-muted float-end ms-3 pe-1 cursor-pointer closeBtn"
        ></i>
      )}
    </div>
  );
};

export default TagComponent;
